import "./style.css";
import gsap from "gsap";

export default class Hero {
  static selector = ".s-sticky-callout";

  constructor(block) {
    this.block = block;
    this.$desktop = block.querySelector(".s-sticky-callout__desktop");
    this.$mobile = block.querySelector(".s-sticky-callout__mobile");
    this.$footer = document.querySelector("footer");
    this.$footer.classList.add("s-footer__has-sticky");
  }

  onScroll({ y }) {
    const yPosition = -(128 - y) > 0 ? 0 : -(128 - y);
    gsap.set(this.$desktop, { y: yPosition });

    this.$mobile.classList[y > 10 ? "add" : "remove"]("__scrolled");
    const footerY = this.$footer.getBoundingClientRect().y - window.innerHeight;
    // gsap.set(this.$mobile, { bottom: footerY <= 0 ? -footerY : 0 });
  }

  onDestroy() {
    this.$footer.classList.remove("s-footer__has-sticky");
  }
}
